import { useContext } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

import { AuthContext } from "../services/context";
import Login from "./Auth/Login";
import LoadingPage from "./common/LoadingPage";

export default function AnonRoute() {
  const location = useLocation();
  const token = localStorage.getItem("token");

  const { user, loading } = useContext(AuthContext);

  if (loading) {
    return <LoadingPage />;
  }

  if (user && token) {
    return <Navigate to={location.state?.returnTo ?? "/app"} />;
  }

  if (location.pathname === "/login" || location.pathname === "/") {
    return <Login />;
  }

  return <Outlet />;
}
